export const WidgetAnalyticsOptions = {
  singlepage: 'Single Page Widget',
  promo: 'Promo Widget',
  multistep: 'Multistep Widget'
};



// WEBPACK FOOTER //
// ./app/widgets/widgetanalyticsoptions.ts